import { IconName } from '@etna-trader/etna-ui/dist/components/icon/icon-pack';

export enum SettingsMenuReactCodes {
    MainPage = 'MainPage',
    Users = 'User',
    UserGroups = 'UserGroups',
    Accounts = 'Accounts',
    Audits = 'Audits',
    Positions = 'Positions',
    Transactions = 'Transactions',
    BrokerLevelPositions = 'BrokerLevelPositions',
    Securities = 'Securities',
    Current = 'Current',
    DTCMessages = 'DTCMessages',
    Reports = 'Reports',
    ClearingBank = 'ClearingBank',
    ACATRequests = 'ACATRequests',
    UserManagement = 'UserManagement',
    Clients = 'Clients',
    Send1099 = 'Send 1099',
    Orders = 'Orders',
    LoginWizard = 'LoginWizard',
    Preferences = 'preferences',
    AccountDetails = 'AccountDetails',
    MyPortfolioPage = 'MyPortfolioPage',
    RIADashboardPage = 'RIADashboardPage',
    OperationsDashboardPage = 'OperationsDashboardPage',
    RIAListingPage = 'RIAListingPage',
    AccountStatement = 'AccountStatement',
    ThresholdPage = 'ThresholdPage',
    RIANotificationPage = 'RIANotificationPage',
    TradeOrderPage = 'TradeOrderPage',
    TradeOrderForm = 'TradeOrderForm',
}

interface ITabBase {
    name: string;
    path: string;
}

export interface ITab extends ITabBase {
    reactCode: SettingsMenuReactCodes;
}

export interface IRoute extends ITabBase {
    tabs: ITab[];
    icon: IconName | null;
}

export interface IRouteGroup extends ITabBase {
    routeGroups: IRouteGroup[] | null;
    routes: IRoute[] | null;
    tabs: ITab[] | null;
    icon: IconName | null;
}
